import React, { useEffect, useState, useRef, useContext } from "react";
import { Container, Row } from "react-bootstrap";

import { useTheme } from "hooks";
import { CountContext } from "contexts";
import useConfirm from "hooks/useConfirm";
import useMessage from "hooks/useMessage";
import ToolTip from "components/ToolTip/ToolTip";
import { ArchivoManager } from "managers/archivo.manager";
import IconButton from "components/IconButton/IconButton";
import useExceptionHandler from "hooks/useExceptionHandler";
import DocumentoUploader from "components/Archivo/DocumentoUploader";
import ModalContainer from "components/ModalContainer/ModalContainer";
import "./Attachment.styles.scss";
import { SvgComponent } from "components/SvgComponent/SvgComponent";

const Attachments = (props) => {
  const [documentosList, setDocumentosList] = useState([]);
  const [modal, setModal] = useState(false);
  const { handleException } = useExceptionHandler();
  const { Confirm, Types } = useConfirm();
  const { Message } = useMessage();
  const childRef = useRef();
  const { theme } = useTheme();
  const { count, setCount } = useContext(CountContext)
    ? useContext(CountContext)
    : {};
  useEffect(() => {
    props.showLoading();
    if (props.fuente && props.modulo && props.referencia) {
      searchFiles();
    }
  }, [props.referencia]);

  const searchFiles = () => {
    ArchivoManager.listarDocumentos({
      CompaniaId: props.companiaId,
      Fuente: props.fuente,
      Modulo: props.modulo,
      DocumentoIdSec: props.referencia,
      EsPaginable: false
    })
      .then((res) => {
        setDocumentosList(res.Data);
        if (setCount) {
          setCount(res.Data.length);
        }
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        props.hideLoading();
      });
  };

  const getExtension = (fileName) => {
    var re = /(?:\.([^.]+))?$/;
    return re.exec(fileName)[1];
  };

  const downloadById = (Id) => {
    const file = documentosList.find((doc) => {
      return doc.IdSec == Id;
    });

    const link = document.createElement("a");
    link.target = "_blank";

    let filename = file.Nombre;
    const rutaExtension = file.Ruta.split(".").pop();
    const nombreExtension = file.Nombre.split(".").pop();

    if (rutaExtension !== nombreExtension) {
      filename += `.${rutaExtension}`;
    }

    link.download = filename;

    const request = {
      IdSec: Id,
      CompaniaId: props.companiaId
    }

    ArchivoManager.descargarDocumentoPorId(request)
      .then((res) => {
        link.href = URL.createObjectURL(res);
        link.click();
      })
      .catch((error) => {
        handleException(error);
      });
  };

  const removeFile = (documento) => {
    props.showLoading();
    ArchivoManager.borrarDocumentoPorId(documento.IdSec)
      .then((res) => {
        setDocumentosList(res.Data);
        Message({ message: "Eliminado exitosamente" });
      })
      .catch((error) => {
        handleException(error);
      })
      .finally(() => {
        props.hideLoading();
      });
  };

  function showConfirm(documento) {
    Confirm({
      type: Types.TYPE_DEFAULT,
      title: "Eliminar documento",
      textBody: "¿Desea Continuar?",
      onConfirm: () => removeFile(documento),
      onCancel: onCancelar,
    });
  }

  function onCancelar() { }

  const handleSave = () => {
    props.showLoading();
    childRef.current.grabar();
    handleClose();
    setTimeout(() => {
      searchFiles();
    }, 2000);
    props.hideLoading();
  };

  const handleClose = () => {
    setModal(!modal);
  };
  const showModal = () => {
    setModal(true);
  };

  const Modal = () => {
    return (
      <ModalContainer
        showModal={modal}
        title="Subir Archivo"
        size="s"
        grabar={handleSave}
        cerrar={handleClose}
      >
        <DocumentoUploader
          ref={childRef}
          showLoading={props.showLoading}
          hideLoading={props.hideLoading}
          referencia={props.referencia}
          fuente={props.fuente}
          modulo={props.modulo}
          multiple={true}
        />
      </ModalContainer>
    );
  };

  return (
    <>
      <Container>
        {modal && Modal()}
        <Row className="p-0">
          <div className="col-md-12">
            <div className="card m-b-30  mt-0 p-0">
              <div className="card-header p-0">
                <div className="row align-items-center p-0">
                  {!props.ocultarHeader && (
                    <div className="col-8">
                      <h5 className=" m-0 p-0">{props.label ?? "Documentos"}</h5>
                    </div>
                  )}
                  <div
                    className={`${!props.ocultarHeader ? "col-4" : "col-12"
                      } d-flex m-0 p-0`}
                    style={{ justifyContent: "flex-end" }}
                  >
                    {!(props.readonly ?? false) &&
                      <IconButton
                        onClick={showModal}
                        styles={{ padding: "0.5rem 1.5rem 0rem 0rem" }}
                      >
                        <ToolTip message="Subir Archivo">
                          <SvgComponent iconName="Attach-file" />
                        </ToolTip>
                      </IconButton>
                    }
                  </div>
                </div>
              </div>

              <div
                className="card-body product-file-type"
                style={{
                  overflowY: "scroll",
                  maxHeight: props.maxHeight ?? "500px",
                }}
              >
                <ul className="list-unstyled">
                  {documentosList.length ? (
                    documentosList.map((documento) => {
                      return (
                        <li
                          className="media mb-3"
                          style={{ alignItems: "center" }}
                        >
                          <span
                            onClick={() => downloadById(documento.IdSec)}
                            className="d-flex mr-3 align-self-center img-icon primary-rgba text-primary"
                            style={{
                              justifyContent: "center",
                              alignItems: "flex-end",
                              cursor: "pointer",
                            }}
                          >
                            <p style={{ fontSize: "18px" }}>
                              {"." + getExtension(documento.Ruta)}
                            </p>
                          </span>
                          <div
                            onClick={() => downloadById(documento.IdSec)}
                            style={{ cursor: "pointer" }}
                            className="media-body"
                          >
                            <h5
                              className=" mb-1  "
                              style={{ fontSize: "14px", fontWeight: "bold" }}
                            >
                              {documento.Nombre}
                            </h5>
                          </div>
                          <IconButton title="Descargar">
                            <i
                              className="fa fa-download"
                              onClick={() => downloadById(documento.IdSec)}
                              style={{ color: "black", cursor: "pointer" }}
                            ></i>
                          </IconButton>
                          
                          {!(props.readonly ?? false) &&
                            <IconButton title="Eliminar">
                              <i
                                className="fa fa-trash"
                                onClick={() => showConfirm(documento)}
                                style={{ color: "black" }}
                              ></i>
                            </IconButton>
                          }
                        </li>
                      );
                    })
                  ) : (
                    <h6 className="h6">No hay Documentos</h6>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default Attachments;
